import "vue";

// When to use this file❔
// This file is used to define types that are used throughout the project
// Generally try to keep types next to components/features rather than use this file to keep it small

export interface LinkData {
   type: "link";
   text: string;
   url: string;
   isExternal?: boolean;
   target?: "_blank" | "_self";
}

export interface ButtonData {
   type: "button";
   text: string;
   action: string;
}

export interface ImageData {
   type: "image";
   url: {
      xl?: string;
      lg?: string;
      md?: string;
      sm?: string;
      xs?: string;
   };
   altTag: string;
}

export interface RichText {
   type: "doc";
   content: RichTextElement[];
}

export interface RichTextElement {
   type: string;
   content: any[];
}

// All the colour themes available for use in the project
export enum Theme {
   White = "white",
   BrandDark = "brand-dark",
   BrandLight = "brand-light",
   WhiteBrand = "white-brand",
   Grey = "grey",
   GreyStatic = "grey-static", // Only for modal X button
   Black = "black",
   Purple = "purple",
   PurpleDark = "purple-dark",
   Pink = "pink",
   PinkDark = "pink-dark",
   Green = "green",
   GreenDark = "green-dark",
   Tan = "tan",
   TanDark = "tan-dark",
   Sand = "sand",
   SandDark = "sand-dark",
   GradientOrange = "gradient-orange",
   Disabled = "disabled",
   Danger = "danger",
}

// button themes are defined locally in the project (an Admin never has control over button styling)
export type ButtonTheme = Theme;

// themes that will come from the BE
export type ContainerTheme = Theme;

// Kits
// -----------------------------------------
// NOTE: the Kit and KitOrderData interfaces are not exhaustive and include only the properties used by the methods in this file.
interface Kit {
   createdAt: string | null;
   completedAt: string | null;
   labReceivedAt: string | null;
   trackingReturnReceivedAt: string | null;
   trackingReturnStartedAt: string | null;
}

export interface KitOrderData {
   trackingOutReceivedAt: string | null;
   shippedOutAt: string | null;
   kits: Kit[];
}

// Global Window
// -----------------------------------------
declare global {
   interface Window {
      loadFacebookPixel?: (code: string) => void;
      fbq?: FBQFunction;
   }

   interface FBQFunction {
      (command: string, ...args: any[]): void;
      callMethod?: (command: string, ...args: any[]) => void;
      queue?: any[];
      push?: (cmd: any[]) => void;
      loaded?: boolean;
      version?: string;
   }
}

// Vue Specific
// -----------------------------------------
// used in main.ts to set the devtools option
declare module "@vue/runtime-core" {
   interface AppConfig {
      devtools?: boolean;
   }
}
